import { render, staticRenderFns } from "./Receita.vue?vue&type=template&id=49767dc7"
import script from "./Receita.vue?vue&type=script&lang=js"
export * from "./Receita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports